import { Badge } from "./ui/badge";
import { ProductStatus } from "../types/Products";

export default function StatusBadge({ status }: { status: ProductStatus }) {
    const statusClass: Record<ProductStatus, string> = {
        "Not started": "bg-destructive text-destructive-foreground",
        Optimizing: "bg-primary text-primary-foreground",
        Ready: "bg-[hsl(var(--chart-3))] text-white",
        Optimized: "bg-[hsl(var(--chart-2))] text-white",
        Paused: "bg-muted text-muted-foreground",
    };

    const className = statusClass[status];

    return <Badge className={className}>{status}</Badge>;
}
